module.exports = __webpack_public_path__ + "img/giroflee_quarantaine.2e2c081e.jpg";